import { useState } from 'react';

export const TOKEN_NAMESPACE = 'cwf-token';
export const TOKEN_EXP_NAMESPACE = 'cwf-exp';

export default function useToken() {
    const getToken = () => {
        const token = localStorage.getItem(TOKEN_NAMESPACE);
        const exp = localStorage.getItem(TOKEN_EXP_NAMESPACE);

        // Check locally if token is expired
        const timestamp = new Date().getTime() / 1000;
        if (exp && exp < timestamp) {
            console.log('Token Expired.');
            return null;
        }

        return token;
    };

    const [token, setToken] = useState(getToken());

    const saveToken = (userToken) => {
        if (userToken) {
            // LOGIN
            localStorage.setItem(TOKEN_NAMESPACE, userToken?.token);
            localStorage.setItem(TOKEN_EXP_NAMESPACE, userToken?.exp);
            setToken(userToken?.token);
        } else {
            // LOGOUT
            localStorage.removeItem(TOKEN_NAMESPACE);
            localStorage.removeItem(TOKEN_EXP_NAMESPACE);
            setToken(null);
        }
    };

    const isAuthenticated = async () => {
        const _token = getToken();
        const response = await fetch(`${process.env.REACT_APP_PROXY_URL || ''}/api/loggedin`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${_token}`,
            },
        });
        return response?.status === 200;
    };

    return {
        isAuth: isAuthenticated,
        setToken: saveToken,
        token,
    };
}
